import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import AddUserInnerComp from './AddUserInnerComp';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { TitleBar } from '../common/theme';

import TextInputHelp from '../common/generic/TextInputHelp';
import TextInput from '../common/generic/TextInput';
import Form from 'react-bootstrap/Form';
import { toArray } from '../../Utils';
import { getCreateUserStatus, getCreateFeildStatus } from '../../ApiHelper';
import Dialog from '../common/Dialog';
import Container from 'react-bootstrap/Container';

const BulkStudentImport = ({pageState}) => <>
    <br/>
    <Alert variant='warning'>
        <h4> Bulk Add Instructions </h4>
        <p> When adding more than a few students to a class, it is recommended to use the "Bulk Add Students" button below </p>
    </Alert>
    <div className="form-group">
        <Row>
            <Button onClick={()=>pageState.showBulkStudentScreen()} variant="warning">Bulk Add Students</Button>
        </Row>
    </div>
</>;

const BulkClassImport = ({pageState}) => <>
    <br/>
    <Alert variant='warning'>
        <h4> Import Instructions </h4>
        <p> It is recommended to for schools with many students and classes to import their data from a file.  <a href="https://essentialskills.com/importing" rel="noopener noreferrer" target="_blank"> Click here for instructions </a></p>
    </Alert>
    <div className="form-group">
        <Row>
            <Button onClick={()=>pageState.showImportUsersScreen()} variant="warning">Import Class/Students from CSV file</Button>
        </Row>
    </div>
</>;

const AddUserComp = ({ pageState  }) => {
    const [userName, setUserName] = useState('');
    const [loginName, setLoginName] = useState('');
    const [password, setPassword] = useState('');
    const [saving, setSaving] = useState('');
    const [dialog, setDialog] = useState({show:false});

    const saveUser = (type) =>{
        if(pageState.pageType==='Class')
            saveClass();
        if(pageState.pageType==='Student')
            saveStudent();
    };

    const saveStudent =()=> {
        let pass = (password) ? password.trim() : '';
        let allStudents = toArray(pageState.database['getStudentsForClass'].data);
        let statusName = getCreateUserStatus('Name',userName.trim(),true,allStudents.map(e=>e.Name));
        let statusLogin = getCreateUserStatus('Username',loginName.trim(),true,allStudents.map(e=>e.CompareName));
        let statusPassword = getCreateFeildStatus('Password',pass, false);

        if(statusName.error){
            setDialog({title:'Problem with the student name...', text:statusName.error, show:true});
            return;
        }
        if(statusLogin.error){
            setDialog({title:'Problem with the username...', text:statusLogin.error, show:true});
            return;
        }
        if(statusPassword.error){
            setDialog({title:'Problem with the password...', text:statusPassword.error, show:true});
            return;
        }

        let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
        let currentLimit = pageState.database['userLimit'];
        currentNumStudents++;
        if(currentNumStudents > currentLimit && currentLimit!==-1){
            setDialog({title:'Too many students', text:'You have exceeded your licence limit. Please call 1-800-753-3727 to add more students.', show:true});
            return;
        } 

        let classID = pageState.showStudentTableComp.classInfo.ClassID;
        let schoolID = pageState.database['getCustomer'].data['ID'];

        let saveStudentQuery = {
            params: `${schoolID}~${classID}~${userName.trim()}~${loginName.trim()}~${pass}~0~0`,
            func:'addStudent',
        };

        pageState.database['getCustomer'].data['NumStudents'] = currentNumStudents+'';         

        pageState.request(saveStudentQuery);
        setSaving(true);
    };

    const saveClass =()=> {
        let allClasses = toArray(pageState.database['getAllClasses'].data);
        let statusName = getCreateUserStatus('Name',userName.trim(),true,allClasses.map(e=>e.Classname));
        let statusLogin = getCreateUserStatus('Username',loginName.trim(),true,allClasses.map(e=>e.Username));
        let statusPassword = getCreateFeildStatus('Password',password, true);

        if(statusName.error){
            setDialog({title:'Problem with the class name...', text:statusName.error, show:true});
            return;
        }
        if(statusLogin.error){
            setDialog({title:'Problem with the username...', text:statusLogin.error, show:true});
            return;
        }
        if(statusPassword.error){
            setDialog({title:'Problem with the password...', text:statusPassword.error, show:true});
            return;
        }

        let schoolID = pageState.database['getCustomer'].data['ID'];
        let saveClassQuery = {
            params: `${schoolID}~${userName.trim()}~${password.trim()}~default~None~N~N~N~0~80~${loginName.trim()}`,
            func:'addClass',
        };

        let currentNumClasses = parseInt(pageState.database['getCustomer'].data['NumClasses']);
        pageState.database['getCustomer'].data['NumClasses'] = (currentNumClasses + 1)+'';

        pageState.request(saveClassQuery);
        setSaving(true);
    };

    useEffect(()=>{
        //if(pageState.pageType==='Class') return;

        if(pageState.database['addClass'] && pageState.database['addClass'].isLoaded){            
            let schoolID = pageState.database['getCustomer'].data['ID'];
            let getAllClassesQuery = {
                params: schoolID,
                func:'getAllClasses',
            };            
            pageState.request(getAllClassesQuery);

            if(window.confirm('Click "OK" to add students now, or "Cancel" to let teachers add their students later')){
                pageState.setShowStudentTableComp({...pageState.showStudentTableComp, display:false, classInfo: {ClassID: pageState.database['addClass'].data['classID'], Classname: userName} }); 
                pageState.internalUpdate('getStudentsForClass',{isLoaded:true, data:{}});                
            }
            else{
                setSaving(false);
                setUserName(''); setLoginName(''); setPassword('');
                pageState.closeAddUserScreen(pageState.pageType);
            }
            pageState.deleteThis('addClass');
        }
    },[pageState.database['addClass']]);

    useEffect(()=>{
        if(pageState.database['addStudent'] && pageState.database['addStudent'].isLoaded){

            let studentID = pageState.database['addStudent'].data.studentID;
            let classID = pageState.showStudentTableComp.classInfo.ClassID;
            let schoolID = pageState.database['getCustomer'].data['ID'];

            let newStudent = {
                studentID,
                Birthday: '0',
                ClassID: classID,
                CompareName: loginName,
                Name: userName,
                Password: password,
                SchoolID: schoolID,
                StudentID: studentID,
                Version: '1'
            };
            let newState = {...pageState.database['getStudentsForClass']};
            newState.data[studentID] = newStudent;
            pageState.internalUpdate('getStudentsForClass', newState);

            setSaving(false);
            setUserName(''); setLoginName(''); setPassword('');

            pageState.closeAddUserScreen(pageState.pageType);
            pageState.deleteThis('addStudent');
        }
    },[pageState.database['addStudent']]);

    useEffect(()=>{
        if(pageState.database['getStudentsForClass'] && pageState.database['getStudentsForClass'].isLoaded && saving){
            setUserName(''); setLoginName(''); setPassword('');
            pageState.showBulkStudentScreen();
            setSaving(false);
        }
    },[pageState.database['getStudentsForClass']]);

    const displayLinkUser = () => pageState.showLinkStudentsScreen();

    return ((!pageState.showAddUserComp)?<></>:<> 
        <TitleBar>
            <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Add a New {pageState.pageType} </h3></Col>
            <Col xs='4'>
            <span className={'pull-right'}>
            {!pageState.isAdmin && <>
                {pageState.database['getStudentsForClass'] && pageState.database['getStudentsForClass'].isLoaded &&
                    toArray(pageState.database['getStudentsForClass'].data).length > 0 &&
                    <> 
                        <Button variant="danger" onClick={()=>{setUserName(''); setLoginName(''); setPassword('');pageState.closeAddUserScreen(pageState.pageType);}}>Close</Button> &nbsp;
                    </>}
                </>}
                {pageState.isAdmin && <>
                {pageState.database['getAllClasses'] && pageState.database['getAllClasses'].isLoaded &&
                    toArray(pageState.database['getAllClasses'].data).length > 0 &&
                    <> 
                        <Button variant="danger" onClick={()=>{setUserName(''); setLoginName(''); setPassword('');pageState.closeAddUserScreen(pageState.pageType);}}>Close</Button> &nbsp;
                    </>}
                </>}
                </span>
            </Col>
        </TitleBar>
        <Row>
            <Col xs='6'>
                <Form>
                    <br/>
                    <TextInputHelp layout={[2,8,2]} onChange={e=>setUserName(e.target.value)} value={userName} name="name" label="Name:" placeholder={pageState.pageType+' Name'} tooltip={((pageState.pageType==='Class')?'Class names are seen by students during login':'Student names seen on reports')}/> 
                    <TextInputHelp layout={[2,8,2]} onChange={e=>setLoginName(e.target.value)} value={loginName} name="login" label="Username:" placeholder={'Required for '+ ((pageState.pageType==='Class')?'teacher':'student') +' login'} tooltip={((pageState.pageType==='Class')?'Used to log  into the Teacher Dashboard':'Students use this name when they login')} />          
                    <TextInput layout={[2,8]} onChange={e=>setPassword(e.target.value)} value={password} name="pass" label="Pass:" placeholder={'Used for '+ ((pageState.pageType==='Class')?'teacher':'student') +' login'} />          
                    <Button onClick={()=>saveUser(pageState.pageType)} variant='success' disabled={saving}>Add to {pageState.pageType} List</Button>
                    {pageState.pageType==='Student' && pageState.isAdmin && <><br/><br/><Button variant="success" onClick={()=>displayLinkUser()} >Link Student(s) from Another Class</Button><Alert variant='warning'><strong>Note:</strong> Linked students still need to login using their main class</Alert></>} 
                </Form>
            </Col>
            {pageState.pageType==='Class' && <Col xs='6'><BulkClassImport pageState={pageState}/></Col>}
            {pageState.pageType==='Student' && <Col xs='6'><BulkStudentImport pageState={pageState}/></Col>}

        </Row>
        <br/>
        <Dialog dialogState={{dialog, setDialog}} />
    </>);
};

export default AddUserComp;